import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";

const ContactUsLink = observer(({ t, isMyUrbanimmersive }) => {
  const contactUs = t("contactUs").toLowerCase();

  return (
    <a
      href={isMyUrbanimmersive ? "https://www.urbanimmersive.com/contact_us" : "https://www.tourbuzz.com/contact_us"}
      target="_blank"
      rel="noopener noreferrer"
      style={{ cursor: "pointer" }}
    >
      {contactUs}
    </a>
  );
});

ContactUsLink.propTypes = {
  t: PropTypes.func.isRequired,
  isMyUrbanimmersive: PropTypes.bool.isRequired,
};

export default withTranslation()(ContactUsLink);
